import { ERROR_MESSAGES } from 'domain/enums'
import { logMessageError } from 'shared/infrastructure/exceptions/logError'
const CREDITAS_AFFILIATES_STATE = 'creditas-affiliates-state'

const getAffiliatesUserInfo = () =>
  localStorage.getItem(CREDITAS_AFFILIATES_STATE)

const getUserInfo = () => {
  const user = JSON.parse(getAffiliatesUserInfo())
  return user
}

const setUserCompanyAndBranch = ({ company, branch }) => {
  try {
    const storage = getUserInfo()
    const storageCopy = {
      ...storage,
      login: {
        user: {
          ...storage.login.user,
          company: { ...company },
          affiliateNameAlias: branch?.source?.toUpperCase(),
        },
      },
    }

    localStorage.setItem(CREDITAS_AFFILIATES_STATE, JSON.stringify(storageCopy))
  } catch (error) {
    logMessageError(
      `${ERROR_MESSAGES.STORAGE_COMPANY_UPDATE_ERROR}`,
      JSON.stringify(error),
    )
  }
}

const setUserSettings = ({ setting }) => {
  try {
    const storage = getUserInfo()
    const storageCopy = {
      ...storage,
      settings: {
        ...storage?.settings,
        ...setting,
      },
    }
    localStorage.setItem(CREDITAS_AFFILIATES_STATE, JSON.stringify(storageCopy))
  } catch (error) {
    logMessageError(
      `${ERROR_MESSAGES.STORAGE_USER_SETTINGS_ERROR}`,
      JSON.stringify(error),
    )
  }
}

const getAgentInformation = () => {
  const affiliate = getUserInfo()
  return {
    name: affiliate.login.user.fullName,
    cpf: affiliate.login.user.document,
    phone: `+55${affiliate.login.user.cellphone}`,
    email: affiliate.login.user.email,
    id: affiliate.login.user.id,
  }
}

const getAgencyInformation = () => {
  const affiliate = getUserInfo()
  return {
    name: affiliate?.login?.user?.company?.socialName,
    cnpj: affiliate?.login?.user?.company?.cnpj,
    id: affiliate?.login?.user?.company?.platformId,
    source: affiliate?.login?.user?.company?.source,
  }
}

const getAgencyInformationWithoutSource = () => {
  const affiliate = getUserInfo()
  return {
    name: affiliate?.login?.user?.company?.socialName,
    cnpj: affiliate?.login?.user?.company?.cnpj,
    id: affiliate?.login?.user?.company?.platformId
  }
}

const getAgencyPermissionsInformation = () => {
  const permissions = getUserInfo()?.settings?.permissions

  return {
    HOME_REFI:  permissions?.homeRefi?.partnerPortal,
    HOME_FIN: permissions?.homeFin?.partnerPortal,
    AUTO_REFI: permissions?.autoRefi?.partnerPortal,
    AUTO_FIN: permissions?.autoFin?.partnerPortal,
  }
}

export {
  getAffiliatesUserInfo,
  getUserInfo,
  setUserCompanyAndBranch,
  setUserSettings,
  getAgentInformation,
  getAgencyInformation,
  getAgencyInformationWithoutSource,
  getAgencyPermissionsInformation,
}
